export const JournalType = {
    ENTITY: { type: 'entity', icon: '👤' },
    LOCATION: { type: 'location', icon: '🗺' },
    NOTE: { type: 'note', icon: '📝' },
}